/**
 * Mastery Label Info — shared utility for learner-facing mastery labels.
 *
 * Used by FamilyPicker and FluencyModulePicker to display mastery status
 * with Dutch labels, Tailwind classes, and ring colors.
 *
 * NOTE: This is different from getMasteryLabel() in utils/formatters.ts,
 * which uses different thresholds and labels for parent/teacher portals.
 *
 * Extracted from FamilyPicker.tsx and FluencyModulePicker.tsx (D-SCAN-2 D2-1).
 */

export interface MasteryLabelInfo {
  label: string
  color: string
  bg: string
  ring: string
}

export function getMasteryLabelInfo(score: number): MasteryLabelInfo {
  if (score === 0)
    return {
      label: 'Nieuw',
      color: 'text-slate-500',
      bg: 'bg-slate-100',
      ring: '#94A3B8',
    }
  if (score <= 25)
    return {
      label: 'Net begonnen',
      color: 'text-orange-600',
      bg: 'bg-orange-100',
      ring: '#F97316',
    }
  if (score <= 50)
    return {
      label: 'Bezig',
      color: 'text-amber-600',
      bg: 'bg-amber-100',
      ring: '#F59E0B',
    }
  if (score <= 70)
    return {
      label: 'Bijna!',
      color: 'text-blue-600',
      bg: 'bg-blue-100',
      ring: '#3B82F6',
    }
  if (score <= 89)
    return {
      label: 'Goed bezig!',
      color: 'text-indigo-600',
      bg: 'bg-indigo-100',
      ring: '#6366F1',
    }
  return {
    label: 'Meester!',
    color: 'text-emerald-600',
    bg: 'bg-emerald-100',
    ring: '#10B981',
  }
}
